import { useMutation, useQueryClient } from "@tanstack/react-query";

import { deleteFootprintingCropPrimaryData } from "services";

import {
  FOOTPRINTING_CROP,
  FOOTPRINTING_CROP_ASSESSMENTS_REQUIRING_REVIEW,
  FOOTPRINTING_CROP_CALCULATED_FOOTPRINT,
  FOOTPRINTING_CROP_FERTILIZERS_MINERAL,
  FOOTPRINTING_CROP_FERTILIZERS_ORGANIC,
  FOOTPRINTING_CROP_PRIMARY_DATA,
  FOOTPRINTING_CROP_PURCHASERS,
  FOOTPRINTING_CROP_SALES,
  FOOTPRINTING_CROP_SEEDINGS,
  FOOTPRINTING_CROP_TILLAGES,
} from "consts";

export const useDeleteFootprintingCropByPrimaryDataId = (farmId: string, cropId: string, year: number, primaryDataId?: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [FOOTPRINTING_CROP_PRIMARY_DATA],
    mutationFn: () => (primaryDataId ? deleteFootprintingCropPrimaryData(primaryDataId) : Promise.resolve(null)),
    onSuccess: async () => {
      const QKs = [
        [FOOTPRINTING_CROP_PRIMARY_DATA, primaryDataId],
        [FOOTPRINTING_CROP_CALCULATED_FOOTPRINT, primaryDataId],
        [FOOTPRINTING_CROP_PRIMARY_DATA, farmId, cropId, year],
        [FOOTPRINTING_CROP_CALCULATED_FOOTPRINT, farmId, cropId, year],
        [FOOTPRINTING_CROP, farmId, cropId, year],
        [FOOTPRINTING_CROP_FERTILIZERS_MINERAL, primaryDataId],
        [FOOTPRINTING_CROP_FERTILIZERS_ORGANIC, primaryDataId],
        [FOOTPRINTING_CROP_PURCHASERS, primaryDataId],
        [FOOTPRINTING_CROP_SALES, primaryDataId],
        [FOOTPRINTING_CROP_SEEDINGS, primaryDataId],
        [FOOTPRINTING_CROP_TILLAGES, primaryDataId],
        [FOOTPRINTING_CROP_ASSESSMENTS_REQUIRING_REVIEW, farmId],
      ];
      await Promise.all(QKs.map((QK) => queryClient.invalidateQueries({ queryKey: QK })));
      await Promise.all(QKs.map((QK) => queryClient.refetchQueries({ queryKey: QK })));
    },
  });
};
